
import React, { useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdDownloadForOffline } from "react-icons/md";
import { BsCloudUpload } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { createHochladenForAccident, deleteHochladen } from "../redux/apiCalls/accidentApiCall";
import { ClipLoader } from "react-spinners";
import { Divider } from "@mui/material";

function Hochladen() {
  const downloadPhoto = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const { lastAccident, createPhotoLoading, getLoading } = useSelector((state) => state.accident);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageState, setImageState] = useState(null);
  const [textImage, setTextImage] = useState("");
  const formData = new FormData();
  const [image, setImage] = useState();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const handleUpload = () => {
    if (!image) {
      return;
    }

    formData.append("image", image);
    formData.append("kind", textImage);
    formData.append("accident", lastAccident._id);
    dispatch(createHochladenForAccident(formData)).then(() => {
      setIsModalOpen(false);
      setTextImage("");
      setImage(null);
    });
  };

  const renderDate = (e) => {
    const dateString = e;
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}.${month}.${year}`;
  };

  const role = sessionStorage.getItem("role");

  return (
    <div className="overflow-x-auto">
      {lastAccident.hochladen.length > 0 ? (
        <table className="min-w-full border border-gray-300 rounded-lg shadow-lg">
          <thead className="bg-gradient-to-r from-black to-[#DAA520] text-white">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-[700] border-b border-gray-400">Hochladen</th>
              <th className="px-6 py-3 text-left text-sm font-[700] border-b border-gray-400">ADatum</th>
              <th className="px-6 py-3 text-center text-sm font-[700] border-b border-gray-400">Aktion</th>
            </tr>
          </thead>
          <tbody>
            {lastAccident.hochladen.map((row, index) => {
              console.log(row);
              return (
                <tr
                  key={row.id}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                  } hover:bg-gray-200 transition-all`}
                >
                  <td className="px-6 py-[5px] text-sm font-[700] border-b border-gray-300">
                    <p>{row.kind}</p>
                  </td>
                  <td className="px-6 py-[5px] text-sm font-[700] border-b border-gray-300">
                    {renderDate(row.createdAt)}
                  </td>
                  <td className="px-6 py-[5px] text-center border-b border-gray-300">
                    {role === "admin" && (
                      <button
                        onClick={() => {
                          dispatch(deleteHochladen(row._id));
                        }}
                        
                        className="text-[#fe4040] transition-all hover:text-[#d85f5f] mx-2"
                      >
                        <RiDeleteBin6Line className="text-[22px]" />
                      </button>
                      
                    )}
                    <button
                      className="text-[#3dba50] transition-all hover:text-green-700 mx-2"
                      onClick={() => setImageState(row.hochPhoto.url)}
                    >
                      {/* <FaEye className="text-[22px]" /> */}
                    </button>
                    <button className="text-[rgb(255,189,89)] transition-all hover:text-blue-700">
                      <MdDownloadForOffline
                        onClick={() => {
                          downloadPhoto(row.hochPhoto.url);
                        }}
                        className="text-[25px]"
                      />
                    </button>
                    <div className="text-[rgb(255,189,89)] transition-all hover:text-blue-700 ml-[2px]">
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="text-center mt-[10px] font-bold text-[20px]">Es wurde noch keine Unterlagen hochgeladen</div>
      )}
<div className="fixed sm:absolute bottom-4 left-1/2 transform -translate-x-1/2">
  <button
    onClick={() => setIsModalOpen(true)}
    className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border border-black rounded shadow-md text-sm sm:text-base whitespace-nowrap"
  >
    + Neues Dokument hochladen
  </button>
</div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-[#333] bg-opacity-[0.5] flex items-center justify-center z-50">
          <div
            className="bg-[rgb(237,237,235)] p-6 rounded-lg shadow-lg w-[600px] animate-fade-in-down"
            style={{ animationDuration: "0.3s" }}
          >
            <h2 className="text-lg font-bold mb-4 text-center">Daten Name</h2>
            <div className="flex items-center mb-4 justify-between">
              <div className="flex items-center">
              <input
                onChange={(e) => {
                  setImage(e.target.files[0]);
                }}
                type="file"
                className="hidden"
                ref={fileInputRef}
                id="fileInputRef"
              />
<label
    htmlFor="fileInputRef"
    className="block text-sm text-gray-500 py-2 px-4 rounded-lg border border-gray-300 bg-blue-50 text-blue-700 hover:bg-blue-100 cursor-pointer"
>
    Datei auswählen
</label>
<span id="fileName" className="ml-2 text-sm text-gray-500">
    {image ? image.name : "Keine Datei ausgewählt"}
</span>
              </div>
              {createPhotoLoading ? (
                <div className="bg-blue-500 font-[700] text-white px-4 py-2 rounded-r-md hover:bg-blue-600">
                  <ClipLoader color="fff" />
                </div>
              ) : (
                <button
                  onClick={handleUpload}
                  className="bg-blue-500 font-[700] text-white px-4 py-2 rounded-r-md hover:bg-blue-600"
                >
                  UPLOAD
                </button>
              )}
            </div>
            <input type="text" value={textImage} onChange={(e) => {setTextImage(e.target.value)}} placeholder=" Bildname / Datei" className="bg-[#fff] p-[10px] rounded-lg shadow-lg animate-fade-in-down outline-none w-[100%]"/>
            <div className="flex justify-center">
              <div className="text-blue-500 text-4xl">
                <i className="fas fa-cloud-upload-alt"></i>
              </div>
            </div>
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400"
              >
                Close
              </button>
              <button className="px-4 py-2 cursor-pointer bg-transparent">
                <BsCloudUpload className="text-[29px] text-[#54d8fb] transition-all hover:text-blue-700" />
              </button>
            </div>
          </div>
        </div>
      )}
      {imageState && (
        <div className="fixed inset-0 bg-[#333] bg-opacity-[0.5] flex items-center justify-center z-50">
          <div
            className="bg-[rgb(237,237,235)] p-6 rounded-lg shadow-lg animate-fade-in-down"
            style={{ animationDuration: "0.3s" }}
          >
            <h2 className="text-lg font-bold mb-4 text-center">Image Preview</h2>
            <img src={imageState} alt="Preview" className="max-w-full max-h-[80vh] mx-auto" />
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setImageState(null)}
                className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Hochladen;
